import {
  Globe, Mail, Phone, MessageCircle, MessageSquare,
  Instagram, Facebook, Twitter, Youtube, Linkedin, Twitch, Github,
  Send, AtSign, Music, Music2, Video, Camera, Image as ImageIcon,
  Heart, Star, ThumbsUp, Award, Trophy, Crown, Sparkles, Zap,
  ShoppingCart, ShoppingBag, CreditCard, DollarSign, Percent, Tag,
  Truck, Package, Box, Store, Building2, MapPin, Map,
  User, Users, UserPlus, UserCheck, Smile, Frown, Meh,
  Bell, Megaphone, Mic, Headphones, Radio, Tv, Newspaper,
  BookOpen, GraduationCap, Briefcase, Lightbulb, Target,
  Calendar, Clock, Bookmark, Tag as TagIcon, Hash, Link2,
  Search, Filter, Settings, Shield, Lock,
} from 'lucide-react';

// Mirror of the admin-dashboard icon registry. Keys MUST match exactly so a
// `{ icon: "instagram" }` saved by the admin renders here.
const ICONS = {
  instagram: Instagram, facebook: Facebook, twitter: Twitter, youtube: Youtube,
  linkedin: Linkedin, twitch: Twitch, github: Github, tiktok: Music2,
  snapchat: Camera, whatsapp: MessageCircle, telegram: Send, discord: MessageSquare,
  reddit: AtSign, threads: AtSign,
  email: Mail, phone: Phone, chat: MessageSquare, notification: Bell,
  megaphone: Megaphone, microphone: Mic, headphones: Headphones, radio: Radio,
  tv: Tv, newspaper: Newspaper,
  website: Globe, link: Link2, search: Search, hashtag: Hash,
  cart: ShoppingCart, bag: ShoppingBag, card: CreditCard, money: DollarSign,
  discount: Percent, tag: Tag, truck: Truck, package: Package, box: Box,
  store: Store, business: Building2, pin: MapPin, map: Map,
  user: User, users: Users, newUser: UserPlus, verifiedUser: UserCheck,
  heart: Heart, star: Star, thumbsUp: ThumbsUp, smile: Smile, meh: Meh, frown: Frown,
  award: Award, trophy: Trophy, crown: Crown, sparkles: Sparkles, zap: Zap,
  music: Music, video: Video, image: ImageIcon, book: BookOpen,
  education: GraduationCap, briefcase: Briefcase, lightbulb: Lightbulb,
  target: Target, calendar: Calendar, clock: Clock, bookmark: Bookmark,
  tagAlt: TagIcon, filter: Filter, settings: Settings, shield: Shield, lock: Lock,
} as const;

type IconKey = keyof typeof ICONS;

function isIconKey(name: string | null | undefined): name is IconKey {
  return !!name && Object.prototype.hasOwnProperty.call(ICONS, name);
}

export function QIcon({ name, size = 16, className }: { name: string | null | undefined; size?: number; className?: string }) {
  if (!isIconKey(name)) return null;
  const Comp = ICONS[name];
  return <Comp size={size} className={className} />;
}
